import { render, staticRenderFns } from "./SupplierPerformanceReportLeftBarChart.vue?vue&type=template&id=f10a1a3e&scoped=true&"
import script from "./SupplierPerformanceReportLeftBarChart.vue?vue&type=script&lang=js&"
export * from "./SupplierPerformanceReportLeftBarChart.vue?vue&type=script&lang=js&"
import style0 from "./SupplierPerformanceReportLeftBarChart.vue?vue&type=style&index=0&id=f10a1a3e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f10a1a3e",
  null
  
)

export default component.exports